import React from "react";
import HTMLReactParser from "html-react-parser";
import { useSelector } from "react-redux";
import { selectLocalizationData } from "../../features/localization/localizationSlice";
import {
  selectBannersData,
  selectBannersError,
} from "../../features/banners/bannersSlice";
import { SUPPORTED_REGIONS } from "../../../shared/enums";
import { getAir3BuyUrl } from "../../static-data/shopUrls";

/**
 * @param pathname
 * @param topBarRef
 * @returns {null|JSX.Element}
 * @constructor
 */

const TopBar = ({ pathname, topBarRef, className = "" }) => {
  const localization = useSelector(selectLocalizationData);
  const banners = useSelector(selectBannersData) || [];
  const error = useSelector(selectBannersError);

  const regionSpecific = banners
    ? banners.find((banner) => banner.region === localization.region)
    : null;
  const pageSpecific = banners
    ? banners.find((banner) => banner.pathname === pathname)
    : null;

  let banner = pageSpecific || regionSpecific;

  if (
    !banner &&
    localization.region === SUPPORTED_REGIONS.AU &&
    !error
  ) {
    const buyUrl = getAir3BuyUrl(SUPPORTED_REGIONS.AU);
    banner = {
      value: `Air3 Has Landed Down Under 🇦🇺 <a href='${buyUrl}' style='text-decoration: none; color: inherit;'><strong>Preorder Now</strong></a>`,
      hidden: false,
    };
  }

  return error || !banner || banner.hidden ? null : (
    <div className={`top-bar${className}`} ref={topBarRef}>
      <div className="container">
        <p className="top-bar__info">
          {HTMLReactParser(banner.value || banner.text)}
        </p>
      </div>
    </div>
  );
};

export default TopBar;
